import styled from 'styled-components';

export const Title = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  color: #757575; /* Matches the image's title color */
`;

export const Description = styled.p`
  font-size: 12px;
  text-align: center;
  color: #666666;
`;